import { useCallback, useContext, useEffect, useState } from "react";
import ModelElements from "../ModelElements";
import { ProductModelProps } from "../ModelViewerProduct";
import ProductTextureContext from "../_contexts/ProductTextureContext";
import useGLB from "../_hooks/useGLB";
import { FindMaterial, FindObject } from "../../Common/Utils/ThreeTools";

export default function Notebook(props: ProductModelProps) {
    const [forceUpdate, setForceUpdate] = useState<string>(Date.now()+"")

    /* Gotta load all the models this way because dynamic paths in URL() aren't picked up by webpack */
    const getUrl = useCallback(() => {
        return {
            'portrait': new URL('@resources/3d-models/glb/spiral-notebook-portrait.glb', import.meta.url),
            'landscape': new URL('@resources/3d-models/glb/spiral-notebook-landscape.glb', import.meta.url),
        }[props.variant]
    }, [props.variant])

    const model = useGLB(getUrl() || new URL(''))
    const elements = model.scene.children
    const [productTexture] = useContext(ProductTextureContext)

    useEffect(() => {
        // Hide Stretcher
        let obj = FindObject("stretcher", elements)
        if (!obj) return
        obj.visible = false

        // Setup page colors
        let mat = FindMaterial("first page", elements)
        if (mat) mat.color.setHex(0xf2f0e6)
        
        mat = FindMaterial("pages front", elements)
        if (mat) mat.color.setHex(0xf2f0e6)
        
        mat = FindMaterial("pages side", elements)
        if (mat) mat.color.setHex(0xf2f0e6)
    }, [elements])

    // Handle Spiral Color
    const option_spiralColor = props.options.get('spiral-color')
    useEffect(() => {
        let mat = FindMaterial("plastic", elements)
        if (!mat) return
        mat.color.setHex(option_spiralColor == "white" ? 0xeeeeee : 0x191919)
    }, [elements, option_spiralColor])
    
    // Handle Cover: Unavailable now so defaults to no cover
    const option_frosterPolymerCover = props.options.get('frosted-polymer-cover') ?? 'without-cover'
    useEffect(() => {
        setForceUpdate(Date.now()+"")
        let obj = FindObject("protector", elements)
        if (!obj) return
        obj.visible = option_frosterPolymerCover == "with-cover"
    }, [elements, option_frosterPolymerCover])

    // Apply lab texture
    useEffect(() => {
        if (!elements) return

        let mat = FindMaterial("cover out", elements)
        if(mat){
            mat.map = productTexture
            mat.map.flipY = false
            mat.map.needsUpdate = true
        }
    }, [productTexture, elements])
    
    return <ModelElements forceUpdate={forceUpdate} scene={model.scene}/>
}